module.exports = __webpack_public_path__ + "e6e330effd6236deba423d06410aa413.png";